import script from "./BatchDeletePaymentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchDeletePaymentForm.vue?vue&type=script&setup=true&lang=js"

import "./BatchDeletePaymentForm.vue?vue&type=style&index=0&id=cfb8ea6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfb8ea6e"]])

export default __exports__